import React from "react";
import { Grid } from "@material-ui/core";

import { getApiUrl } from "../../config/api";
import CoinPanel from "./components/coinPanel";
import useRatePolling from "./hooks/useRatePolling";
import { Styles } from '../style/tabContentStyle'

const GOLD_RATE_URL = getApiUrl("gold-rate");
const GOLD_ERROR_MESSAGE = "دریافت نرخ طلا و سکه با خطا مواجه شد.";
const GOLD_RATE_ICONS = {
  IR_COIN_1G: { icon: "🪙", label: "سکه یک گرمی" },
  IR_COIN_BAHAR: { icon: "🪙", label: "سکه بهار آزادی" },
  IR_COIN_EMAMI: { icon: "🪙", label: "سکه امامی" },
  IR_COIN_HALF: { icon: "🪙", label: "نیم سکه" },
  IR_COIN_QUARTER: { icon: "🪙", label: "ربع سکه" },
  IR_GOLD_18K: { icon: "✨", label: "طلای ۱۸ عیار" },
  IR_GOLD_24K: { icon: "💎", label: "طلای ۲۴ عیار" },
  IR_GOLD_MELTED: { icon: "🟨", label: "طلای آب‌شده" },
};

const getGoldRateIcon = (goldRate) => GOLD_RATE_ICONS[goldRate.code] || {
  icon: goldRate.code.includes("COIN") ? "🪙" : "✨",
  label: goldRate.title,
};

const formatPrice = (price) => {
  const numericPrice = Number(price);

  return Number.isFinite(numericPrice)
    ? numericPrice.toLocaleString("fa-IR", { maximumFractionDigits: 2 })
    : price;
};

const formatUnit = (unit) => unit === "TOMAN" ? "تومان" : unit;

const Golds = () => {
  const { data: goldRates, isLoading, error } = useRatePolling(
    GOLD_RATE_URL,
    GOLD_ERROR_MESSAGE
  );

  return (
    <Styles>
      <Grid className="currencies" container>
        <Grid item md={12} xs={12}>
          {isLoading ? (
            <div className="tab-message">در حال دریافت نرخ طلا و سکه...</div>
          ) : goldRates.length === 0 && error ? (
            <div className="tab-message error">{error}</div>
          ) : goldRates.length === 0 ? (
            <div className="tab-message">نرخ طلا و سکه‌ای برای نمایش وجود ندارد.</div>
          ) : (
            <>
              {error && <div className="refresh-error">{error}</div>}
              <Grid container alignItems="stretch" spacing={2}>
                {goldRates.map((goldRate) => {
                  const rateIcon = getGoldRateIcon(goldRate);

                  return (
                    <Grid item md={6} sm={12} xs={12} key={goldRate.code}>
                      <CoinPanel
                        icon={rateIcon.icon}
                        iconLabel={`آیکن ${rateIcon.label}`}
                        title={goldRate.title}
                        displayPrice={formatPrice(goldRate.price)}
                        unit={formatUnit(goldRate.unit)}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Styles>
  );
};

export default Golds;
